import { useContext } from "react";
import PopupContext, { PopupContextType, PopupPayload } from "../context";

export default function usePopup() {
  const ctx = useContext(PopupContext) as PopupContextType | null;

  if (!ctx) throw new Error("usePopup must be used within a PopupProvider");
  return ctx.showPopup as (payload: PopupPayload) => void;
}
